module.exports = __webpack_public_path__ + "static/media/ChocolatesIcon.21e2d745.png";